module.exports = __webpack_public_path__ + "img/hand-pointer.eeabcc7b.svg";